import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { DashboardRoutingModule } from "./dashboard-routing.module";
import { ContainerComponent } from "./components/container/container.component";
import { ChartsComponent } from "./components/charts/charts.component";
import { TransactionDetailsComponent } from "./components/transaction-details/transaction-details.component";
import { MaterialModule } from "@root/modules/material/material.module";
import { FullTransactionHistoryComponent } from "./components/full-transaction-history/full-transaction-history.component";
import { TransactionsComponent } from '@modules/super-admin/components/dashboard/transactions/transactions.component';
import { SharedModule } from "../shared/shared.module";

@NgModule({
  imports: [CommonModule, MaterialModule, DashboardRoutingModule, SharedModule],
  declarations: [
    ContainerComponent,
    ChartsComponent,
    TransactionDetailsComponent,
      TransactionsComponent,
    FullTransactionHistoryComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [SharedModule]
})
export class DashboardModule {}
